import * as React from "react";
import { Box, MenuItem, FormControlLabel, Radio } from "@mui/material";
import { getUnitReport, getDetailsReport, getSingleProperty, addSnapshot } from "state/apis";
import jsPDF from "jspdf";
import html2canvas from "html2canvas";
import "./index.css";
import { TextField, Grid } from "@mui/material";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import dayjs from "dayjs";
import moment from "moment";
import DefaultProperty from "components/DefaultProperty";
import { useSelector } from "react-redux";
import waterMark from "../../assets/burganRealestate.png";
import { toast } from "react-toastify";
import { formatAmount } from "utils/constants";
import Loader from "components/Loader";
import Roundedloader from "components/Roundedloader";

const AllUnits = () => {
    const propertyName = useSelector((state) => state.global.propertyName);
    const property = useSelector((state) => state.global.defaultProperty);
    const [isLoading, setIsLoading] = React.useState(false);
    console.log("isLoading: ", isLoading);
    const [data, setData] = React.useState({});
    const [owner, setOwner] = React.useState({});
    const [openDefaultProperty, setOpenDefaultProperty] = React.useState(false);
    const [monthChecked, setMonthChecked] = React.useState(true);
    const [dateChecked, setDateChecked] = React.useState(false);

    const start = moment().startOf("month").format("YYYY-MM-DD");
    const end = moment().endOf("month").format("YYYY-MM-DD");
    const currentMonth = moment().format("YYYY-MM");

    const [filter, setFilter] = React.useState({
        startDate: start,
        endDate: end,
        monthValue: currentMonth,
        reportType: "Income and expense summary",
    });

    React.useEffect(() => {
        setIsLoading(true);
        if (!property) {
            setOpenDefaultProperty(true);
        } else {
            fetchOwnerData();
            fetchData();
        }

        setIsLoading(false);
    }, [filter.startDate, filter.endDate, monthChecked, property]);

    React.useEffect(() => {
        setIsLoading(true);
        if (!property) {
            setOpenDefaultProperty(true);
        } else {
            fetchData();
        }

        setIsLoading(false);
    }, []);

    const fetchData = async () => {
        try {
            let res = await getUnitReport({
                propertyId: property,
                startDate: filter.startDate,
                endDate: filter.endDate,
            });
            setData(res.data);
            setIsLoading(false);
        } catch (error) {
            console.error("Error fetching data:", error);
        }
    };

    const fetchOwnerData = async () => {
        try {
            let res = await getSingleProperty({
                propertyId: property,
            });

            setOwner(res.data[0]);
            setIsLoading(false);
        } catch (error) {
            console.error("Error fetching data:", error);
        }
    };

    const handleMonthChange = (event) => {
        const isChecked = event.target.checked;
        setMonthChecked(isChecked);
        if (isChecked) {
            setDateChecked(false);
        }
    };

    const handleDateChange = (event) => {
        const isChecked = event.target.checked;
        setDateChecked(isChecked);
        if (isChecked) {
            setMonthChecked(false);
        }
    };

    const handleFrom = (date) => {
        const data = date;
        const formattedDate = data.format("YYYY-MM-DD");

        setFilter((prevData) => ({
            ...prevData,
            startDate: formattedDate,
        }));
    };
    const handleTo = (date) => {
        const data = date;
        const formattedDate = data.format("YYYY-MM-DD");

        setFilter((prevData) => ({
            ...prevData,
            endDate: formattedDate,
        }));
    };
    const handleMonth = (date) => {
        if (!date) return;
        const selectedDate = dayjs(date);

        const startDate = selectedDate.startOf("month").format("YYYY-MM-DD");
        const endDate = selectedDate.endOf("month").format("YYYY-MM-DD");

        setFilter((prevData) => ({
            ...prevData,
            startDate: startDate,
            endDate: endDate,
            monthValue: date ? date.format("YYYY-MM") : null,
        }));
    };

    const handleCloseDefaultProperty = () => {
        setOpenDefaultProperty(false);
    };

    const reportRef = React.useRef();

    const saveSnapshot = async () => {
        console.log("--------------");
        setIsLoading(true);
        const input = reportRef.current;

        try {
            const canvas = await html2canvas(input, { scale: 2 });
            const imgData = canvas.toDataURL("image/png", 0.7);
            const pdf = new jsPDF("l", "mm", "a3");

            const pdfWidth = pdf.internal.pageSize.getWidth();
            const pdfHeight = pdf.internal.pageSize.getHeight();
            const margin = 10;
            const imgProps = pdf.getImageProperties(imgData);
            const imgHeight = (imgProps.height * (pdfWidth - 2 * margin)) / imgProps.width;
            let position = 0;

            while (position < canvas.height) {
                const sectionCanvas = document.createElement("canvas");
                const sectionHeight = Math.min(
                    canvas.height - position,
                    (pdfHeight - 2 * margin) * (imgProps.width / (pdfWidth - 2 * margin))
                );

                sectionCanvas.width = canvas.width;
                sectionCanvas.height = sectionHeight;

                const sectionCtx = sectionCanvas.getContext("2d");
                sectionCtx.drawImage(canvas, 0, -position, canvas.width, canvas.height);

                const sectionImgData = sectionCanvas.toDataURL("image/png", 0.7);

                if (position > 0) pdf.addPage();
                pdf.addImage(
                    sectionImgData,
                    "PNG",
                    margin,
                    margin,
                    pdfWidth - 2 * margin,
                    (sectionHeight * (pdfWidth - 2 * margin)) / canvas.width
                );

                position += sectionHeight;
            }

            const pdfBlob = pdf.output("blob");
            const uniqueFileName = `${propertyName}-unit-${moment(filter.startDate).format(
                "MMM"
            )}-${moment(filter.startDate).format("YYYY")}.pdf`;

            const pdfFile = new File([pdfBlob], uniqueFileName, { type: "application/pdf" });

            const snapshotData = {
                fileName: `${propertyName}-${moment(filter.startDate).format("MMM")}-${moment(
                    filter.startDate
                ).format("YYYY")}-income-and-expense-unit.pdf`,
                uniqueName: uniqueFileName,
                fileUrl: pdfFile,
            };
            console.log("***********");
            const response = await addSnapshot(snapshotData);
            setIsLoading(false);
            toast.success(response.message);
        } catch (error) {
            console.error("Error:", error);
            if (error.response) {
                toast.error(error.response.data.message);
            } else if (error.request) {
                toast.error("No response received from server.");
            } else {
                toast.error("An error occurred. Please try again.");
            }
        }
    };

    const handlePrint = () => {
        const input = reportRef.current;

        html2canvas(input, { scale: 2 }).then((canvas) => {
            const imgData = canvas.toDataURL("image/png");
            const pdf = new jsPDF("p", "mm", "a4");

            const pdfWidth = pdf.internal.pageSize.getWidth();
            const pdfHeight = pdf.internal.pageSize.getHeight();

            const margin = 10; // Add margin (padding)

            // Get the image height and scale it proportionally
            const imgProps = pdf.getImageProperties(imgData);
            const imgHeight = (imgProps.height * (pdfWidth - 2 * margin)) / imgProps.width;

            let heightLeft = imgHeight;
            let position = margin;

            pdf.addImage(imgData, "PNG", margin, position, pdfWidth - 2 * margin, imgHeight);
            heightLeft -= pdfHeight - 2 * margin;

            while (heightLeft > 0) {
                position = heightLeft - imgHeight + margin;
                pdf.addPage();
                pdf.addImage(imgData, "PNG", margin, position, pdfWidth - 2 * margin, imgHeight);
                heightLeft -= pdfHeight - 2 * margin;
            }

            pdf.save(`${propertyName}-income-and-expense-unit.pdf`);
        });
    };

    const handleDownloadCSV = () => {
        const table = document.querySelector("table");
        let csvContent = "";

        // Loop through table rows
        for (const row of table.rows) {
            const rowData = [];
            for (const cell of row.cells) {
                const cellText = cell.textContent.trim().replace(/"/g, '""');
                rowData.push(`"${cellText}"`);
            }
            csvContent += rowData.join(",") + "\n";
        }

        // Create Blob and trigger download
        const blob = new Blob([csvContent], { type: "text/csv" });
        const link = document.createElement("a");
        link.href = URL.createObjectURL(blob);
        link.download = `${propertyName}-income-and-expense-unit.csv`;
        link.click();
        URL.revokeObjectURL(link.href); // Cleanup
    };

    let monthCollection = 0;
    let totalOtherIncome = 0;
    let totalDeposit = 0;
    return (
        <Box m="1.5rem 2.5rem" mb={5}>
            <Box display="flex" justifyContent="flex-end" pt={0} paddingLeft={0}>
                <Grid container spacing={1} p={"5px"} alignItems="center">
                    <Grid item>
                        <FormControlLabel
                            value="month"
                            control={
                                <Radio
                                    checked={monthChecked}
                                    onChange={handleMonthChange}
                                    color="primary"
                                />
                            }
                            label="Month"
                        />
                    </Grid>
                    <Grid item>
                        <FormControlLabel
                            value="date"
                            control={
                                <Radio
                                    checked={dateChecked}
                                    onChange={handleDateChange}
                                    color="primary"
                                />
                            }
                            label="Date Wise"
                        />
                    </Grid>
                    {dateChecked && (
                        <>
                            <Grid item xs={2}>
                                <LocalizationProvider dateAdapter={AdapterDayjs}>
                                    <DatePicker
                                        label="From"
                                        name="contractFrom"
                                        onChange={handleFrom}
                                        value={filter.startDate ? dayjs(filter.startDate) : null}
                                        format="DD/MM/YYYY"
                                        sx={{
                                            width: "100%",
                                            "& .MuiOutlinedInput-root": {
                                                "&.Mui-focused fieldset": {
                                                    borderColor: "primary.main",
                                                },
                                            },
                                            "& .MuiInputLabel-root": {
                                                "&.Mui-focused": {
                                                    color: "primary.main",
                                                },
                                            },
                                        }}
                                    />
                                </LocalizationProvider>
                            </Grid>
                            <Grid item xs={2}>
                                <LocalizationProvider dateAdapter={AdapterDayjs}>
                                    <DatePicker
                                        label="To"
                                        name="contractTo"
                                        onChange={handleTo}
                                        value={filter.endDate ? dayjs(filter.endDate) : null}
                                        format="DD/MM/YYYY"
                                        sx={{
                                            width: "100%",
                                            "& .MuiOutlinedInput-root": {
                                                "&.Mui-focused fieldset": {
                                                    borderColor: "primary.main",
                                                },
                                            },
                                            "& .MuiInputLabel-root": {
                                                "&.Mui-focused": {
                                                    color: "primary.main",
                                                },
                                            },
                                        }}
                                    />
                                </LocalizationProvider>
                            </Grid>
                        </>
                    )}
                    {monthChecked && (
                        <Grid item xs={2}>
                            <LocalizationProvider dateAdapter={AdapterDayjs}>
                                <DatePicker
                                    label={"Month"}
                                    views={["month", "year"]}
                                    name="month"
                                    onChange={handleMonth}
                                    value={filter.monthValue ? dayjs(filter.monthValue) : null}
                                    sx={{
                                        width: "100%",
                                        "& .MuiOutlinedInput-root": {
                                            "&.Mui-focused fieldset": {
                                                borderColor: "primary.main",
                                            },
                                        },
                                        "& .MuiInputLabel-root": {
                                            "&.Mui-focused": {
                                                color: "primary.main",
                                            },
                                        },
                                    }}
                                />
                            </LocalizationProvider>
                        </Grid>
                    )}
                    <Grid item xs></Grid>
                    <Grid item xs="auto">
                        <button className="download-btn" onClick={saveSnapshot}>
                            Snapshot{" "}
                            {/* {isLoading && (
                                <span>
                                    <Roundedloader size={"md"} type={"P"} />
                                </span>
                            )} */}
                        </button>
                    </Grid>
                    <Grid item xs="auto">
                        <button className="download-btn" onClick={handlePrint}>
                            Download PDF{" "}
                            {/* {isLoading && (
                                <span>
                                    <Roundedloader size={"md"} type={"P"} />
                                </span>
                            )} */}
                        </button>
                    </Grid>
                    {/* <Grid item xs="auto">
                        <button className="download-btn" onClick={handleDownloadCSV}>
                            Download CSV
                        </button>
                    </Grid> */}
                </Grid>
            </Box>
            {!property && (
                <DefaultProperty
                    open={openDefaultProperty}
                    onClose={() => handleCloseDefaultProperty}
                />
            )}

            <div className="report-container">
                <div ref={reportRef}>
                    <div style={{ display: "flex", justifyContent: "space-between" }}>
                        <span style={{ fontWeight: "bold", padding: "0px", marginTop: "10px" }}>
                            {monthChecked
                                ? `INCOME & EXPENDITURE REPORT - ${moment(filter.monthValue)
                                      .format("MMMM YYYY")
                                      .toUpperCase()} `
                                : `INCOME & EXPENDITURE REPORT - ${filter.startDate} AND ${filter.endDate}`}
                        </span>
                        <span style={{ fontWeight: "bold", padding: "0px" }}>
                            Printed on: {moment().format("DD MMM YYYY")}
                        </span>
                    </div>
                    <p style={{ fontWeight: "bold" }}> {propertyName}</p>
                    <p style={{ fontWeight: "bold", paddingBottom: "10px" }}> {owner?.address}</p>
                    <div style={{ position: "relative" }}>
                        {/* Watermark image */}
                        {/* <img
                            src={waterMark}
                            alt="Watermark"
                            style={{
                                position: "absolute",
                                top: "50%",
                                left: "50%",
                                transform: "translate(-50%, -50%)",
                                zIndex: 0, // Send the image behind
                                opacity: 1, // Adjust the transparency of the watermark
                                width: "80%", // Set width according to need
                                height: "auto",
                            }}
                        /> */}
                        <table
                            border="1"
                            cellPadding="5"
                            cellSpacing="0"
                            // style={{
                            //     backgroundImage: `url(${waterMark})`,
                            //     backgroundRepeat: "no-repeat",
                            //     backgroundPosition: "center",
                            //     backgroundSize: "contain",
                            //     position: "relative",
                            //     zIndex: 1,
                            // }}
                            style={{
                                position: "relative",
                                zIndex: 1, // Ensure the content stays above the watermark
                                backgroundColor: "rgba(255, 255, 255, 0.9)", // Optional: Adds background for better text visibility
                            }}
                        >
                            <thead>
                                {/* <tr className="no-border">
                                <th colSpan={7} style={{ textAlign: "start" }}>
                                    {monthChecked
                                        ? `${moment(filter.monthValue)
                                              .format("MMMM YYYY")
                                              .toUpperCase()} - INCOME & EXPENDITURE REPORT`
                                        : `${filter.startDate} AND ${filter.endDate}- INCOME & EXPENDITURE REPORT`}
                                </th>
                            </tr>
                            <tr className="no-border">
                                <th colSpan={7} style={{ textAlign: "start" }}>
                                    {propertyName}
                                </th>
                            </tr>

                            <tr style={{ border: "none" }}>
                                <th colSpan={7} style={{ textAlign: "start" }}>
                                    {owner?.address}
                                </th>
                            </tr> */}
                                <tr>
                                    <th style={{ textAlign: "center" }}>PROPERTY</th>
                                    <th style={{ textAlign: "center" }}>YEARLY RENT</th>
                                    <th style={{ textAlign: "center" }}>
                                        {monthChecked
                                            ? `COLLECTION ${moment(filter.monthValue)
                                                  .format("MMMM YYYY")
                                                  .toUpperCase()}`
                                            : `COLLECTION ${filter.startDate} AND ${filter.endDate}`}
                                    </th>
                                    <th style={{ textAlign: "center" }}>RECEIPT NO</th>
                                    <th style={{ textAlign: "center" }}>Deposit</th>
                                    <th style={{ textAlign: "center" }}>CUMULATIVE COLLECTION</th>
                                    <th style={{ textAlign: "center" }}>BALANCE RENT</th>
                                    <th style={{ textAlign: "center" }}>REMARKS</th>
                                </tr>
                            </thead>

                            <tbody>
                                {data && data.units ? (
                                    <>
                                        {data.units.map((val, index) => (
                                            <tr key={index}>
                                                <td>
                                                    {val.unitNumber}
                                                    <br />
                                                    {val?.vacantLabel === "Yes" ? (
                                                        <span style={{ color: "red" }}>Vacant</span>
                                                    ) : (
                                                        ""
                                                    )}
                                                </td>
                                                <td style={{ textAlign: "right" }}>
                                                    {formatAmount(Number(val.yearRent))}
                                                </td>
                                                <td
                                                    style={{
                                                        padding: "0px",
                                                        textAlign: "center",
                                                    }}
                                                >
                                                    <ul
                                                        style={{
                                                            listStyleType: "none",
                                                            padding: 0,
                                                            margin: 0,
                                                        }}
                                                    >
                                                        {val.receipt.length > 0 ? (
                                                            val.receipt.map((ele, idx) => {
                                                                const isLast =
                                                                    idx === val.receipt.length - 1;
                                                                monthCollection += ele.amount;
                                                                return (
                                                                    <li
                                                                        key={idx}
                                                                        style={{
                                                                            padding: "5px",
                                                                            textAlign: "right",
                                                                            borderBottom: isLast
                                                                                ? "none"
                                                                                : "1px solid #ccc",
                                                                        }}
                                                                    >
                                                                        {formatAmount(
                                                                            Number(ele.amount)
                                                                        )}
                                                                    </li>
                                                                );
                                                            })
                                                        ) : (
                                                            <li
                                                                style={{
                                                                    padding: "5px",
                                                                    marginBottom: "5px",
                                                                    textAlign: "right",
                                                                }}
                                                            >
                                                                -
                                                            </li>
                                                        )}
                                                    </ul>
                                                </td>
                                                <td
                                                    style={{
                                                        padding: "0px",
                                                        textAlign: "center",
                                                    }}
                                                >
                                                    <ul
                                                        style={{
                                                            listStyleType: "none",
                                                            padding: 0,
                                                            margin: 0,
                                                        }}
                                                    >
                                                        {val.receipt.length > 0 ? (
                                                            val.receipt.map((ele, idx) => {
                                                                const isLast =
                                                                    idx === val.receipt.length - 1;
                                                                return (
                                                                    <li
                                                                        key={idx}
                                                                        style={{
                                                                            padding: "5px",
                                                                            textAlign: "right",
                                                                            borderBottom: isLast
                                                                                ? "none"
                                                                                : "1px solid #ccc",
                                                                        }}
                                                                        // style={{
                                                                        //     paddingBottom: "5px",
                                                                        //     marginBottom: "5px",
                                                                        //     borderBottom: isLast
                                                                        //         ? "none"
                                                                        //         : "1px solid #ccc",
                                                                        // }}
                                                                    >
                                                                        {`${ele.bankRefNumber}`}
                                                                    </li>
                                                                );
                                                            })
                                                        ) : (
                                                            <li
                                                                style={{
                                                                    padding: "5px",
                                                                    marginBottom: "5px",
                                                                    textAlign: "right",
                                                                }}
                                                            >
                                                                -
                                                            </li>
                                                        )}
                                                    </ul>
                                                </td>
                                                <td
                                                    style={{
                                                        padding: "0px",
                                                        textAlign: "center",
                                                    }}
                                                >
                                                    <ul
                                                        style={{
                                                            listStyleType: "none",
                                                            padding: 0,
                                                            margin: 0,
                                                        }}
                                                    >
                                                        {val.deposits.length > 0 ? (
                                                            val.deposits.map((ele, idx) => {
                                                                const isLast =
                                                                    idx === val.deposits.length - 1;
                                                                totalDeposit += Number(ele.amount);
                                                                return (
                                                                    <li
                                                                        key={idx}
                                                                        style={{
                                                                            padding: "5px",
                                                                            textAlign: "right",
                                                                            borderBottom: isLast
                                                                                ? "none"
                                                                                : "1px solid #ccc",
                                                                        }}
                                                                    >
                                                                        {formatAmount(
                                                                            Number(ele.amount)
                                                                        )}
                                                                    </li>
                                                                );
                                                            })
                                                        ) : (
                                                            <li
                                                                style={{
                                                                    padding: "5px",
                                                                    marginBottom: "5px",
                                                                    textAlign: "right",
                                                                }}
                                                            >
                                                                -
                                                            </li>
                                                        )}
                                                    </ul>
                                                </td>
                                                <td style={{ textAlign: "right" }}>
                                                    {formatAmount(Number(val.receiptAmount))}
                                                </td>
                                                <td style={{ textAlign: "right" }}>
                                                    {formatAmount(Number(val.dueAmount))}
                                                </td>
                                                <td>{"-"}</td>
                                            </tr>
                                        ))}
                                    </>
                                ) : (
                                    <tr>
                                        <td colSpan="20" style={{ textAlign: "center" }}>
                                            Loading...
                                        </td>
                                    </tr>
                                )}
                                {data?.futureReceipts?.length > 0 && (
                                    <>
                                        <tr>
                                            <td colSpan="8" style={{ textAlign: "center" }}></td>
                                        </tr>
                                        <tr>
                                            <td colSpan="8" style={{ textAlign: "start", fontWeight: "bold" }}>
                                                Additional Collections
                                            </td>
                                        </tr>
                                        {data.futureReceipts.map((val, index) => (
                                            <tr key={`fc-${index}`}>
                                                <td>
                                                    {val.unitNumber}
                                                </td>
                                                <td style={{ textAlign: "right" }}>
                                                    {formatAmount(Number(val.yearRent))}
                                                </td>
                                                <td style={{ padding: "0px", textAlign: "center" }}>
                                                    <ul style={{ listStyleType: "none", padding: 0, margin: 0 }}>
                                                        {val.receipt.length > 0 ? (
                                                            val.receipt.map((ele, idx) => {
                                                                const isLast = idx === val.receipt.length - 1;
                                                                monthCollection += ele.amount;
                                                                return (
                                                                    <li key={idx} style={{ padding: "5px", textAlign: "right", borderBottom: isLast ? "none" : "1px solid #ccc" }}>
                                                                        {formatAmount(Number(ele.amount))}
                                                                    </li>
                                                                );
                                                            })
                                                        ) : (
                                                            <li style={{ padding: "5px", textAlign: "right" }}>-</li>
                                                        )}
                                                    </ul>
                                                </td>
                                                <td style={{ padding: "0px", textAlign: "center" }}>
                                                    <ul style={{ listStyleType: "none", padding: 0, margin: 0 }}>
                                                        {val.receipt.length > 0 ? (
                                                            val.receipt.map((ele, idx) => {
                                                                const isLast = idx === val.receipt.length - 1;
                                                                return (
                                                                    <li key={idx} style={{ padding: "5px", textAlign: "right", borderBottom: isLast ? "none" : "1px solid #ccc" }}>
                                                                        {`${ele.bankRefNumber || "-"}`}
                                                                    </li>
                                                                );
                                                            })
                                                        ) : (
                                                            <li style={{ padding: "5px", textAlign: "right" }}>-</li>
                                                        )}
                                                    </ul>
                                                </td>
                                                <td style={{ padding: "0px", textAlign: "center" }}>
                                                    <ul style={{ listStyleType: "none", padding: 0, margin: 0 }}>
                                                        {val.deposits.length > 0 ? (
                                                            val.deposits.map((ele, idx) => {
                                                                const isLast = idx === val.deposits.length - 1;
                                                                totalDeposit += Number(ele.amount);
                                                                return (
                                                                    <li key={idx} style={{ padding: "5px", textAlign: "right", borderBottom: isLast ? "none" : "1px solid #ccc" }}>
                                                                        {formatAmount(Number(ele.amount))}
                                                                    </li>
                                                                );
                                                            })
                                                        ) : (
                                                            <li style={{ padding: "5px", textAlign: "right" }}>-</li>
                                                        )}
                                                    </ul>
                                                </td>
                                                <td style={{ textAlign: "right" }}>
                                                    {formatAmount(Number(val.receiptAmount || 0))}
                                                </td>
                                                <td style={{ textAlign: "right" }}>
                                                    {formatAmount(Number(val.dueAmount || 0))}
                                                </td>
                                                <td>{"-"}</td>
                                            </tr>
                                        ))}
                                    </>
                                )}
                                <tr>
                                    <td style={{ fontWeight: "bold" }}>Total:</td>
                                    <td style={{ textAlign: "right", fontWeight: "bold" }}>
                                        {formatAmount(Number(data?.totalYearlyRent))}
                                    </td>
                                    <td style={{ textAlign: "right" }}>
                                        {formatAmount(Number(monthCollection))}
                                    </td>
                                    <td></td>
                                    <td></td>
                                    <td style={{ textAlign: "right" }}>
                                        {formatAmount(Number(data?.totalCollectedRent))}
                                    </td>
                                    <td style={{ textAlign: "right" }}>
                                        {formatAmount(Number(data?.totalBalanceRent))}
                                    </td>
                                    <td></td>
                                </tr>
                                {/* <tr>
                                <td colSpan={7}></td>
                            </tr> */}
                                <tr>
                                    <td style={{ fontWeight: "bold" }} colSpan={8}>
                                        Expenses
                                    </td>
                                </tr>
                                {data && data.expenses && data.expenses.length > 0 ? (
                                    data.expenses.map((val, index) => (
                                        <tr key={index}>
                                            <td>{val.name}</td>
                                            <td style={{ textAlign: "right" }}>
                                                {formatAmount(Number(val.amount))}
                                            </td>
                                            {/* <td></td>
                                        <td></td>
                                        <td></td>
                                        <td></td>
                                        <td></td> */}
                                        </tr>
                                    ))
                                ) : (
                                    <tr>
                                        <td colSpan="2" style={{ textAlign: "center" }}>
                                            No data available
                                        </td>
                                    </tr>
                                )}
                                <tr>
                                    <td style={{ fontWeight: "bold" }}>Total</td>
                                    <td style={{ textAlign: "right", fontWeight: "bold" }}>
                                        {Number(data.totalExpense).toFixed(2)}
                                    </td>
                                </tr>
                                {/* <tr>
                                <td colSpan={7}></td>
                            </tr> */}
                                <tr>
                                    <td style={{ fontWeight: "bold" }} colSpan={8}>
                                        Summary
                                    </td>
                                </tr>
                                <tr>
                                    <td>Rent Collection</td>
                                    <td style={{ textAlign: "right" }}>
                                        {Number(monthCollection).toFixed(2)}
                                    </td>
                                </tr>
                                {data?.otherIncome?.length > 0 &&
                                    data.otherIncome.map((val, index) => {
                                        totalOtherIncome += val.amount;
                                        return (
                                            <tr key={index}>
                                                <td>
                                                    OTHER INCOME ({val?.unit?.unitNumber}){" "}
                                                    {val.rentAdjustFromDeposit === true
                                                        ? "(Adjusted rent from deposit)"
                                                        : ""}
                                                </td>
                                                <td style={{ textAlign: "right" }}>
                                                    {Number(val.amount).toFixed(2)}
                                                </td>
                                            </tr>
                                        );
                                    })}
                                <tr>
                                    <td>Deposit</td>
                                    <td style={{ textAlign: "right" }}>
                                        {Number(totalDeposit).toFixed(2)}
                                    </td>
                                </tr>
                                <tr>
                                    <td>Expenses Total</td>
                                    <td style={{ textAlign: "right" }}>
                                        {Number(data?.totalExpense).toFixed(2)}
                                    </td>
                                </tr>
                                <tr>
                                    <td style={{ fontWeight: "bold" }}> Balance</td>
                                    <td style={{ textAlign: "right", fontWeight: "bold" }}>
                                        {Number(
                                            parseFloat(monthCollection) +
                                                parseFloat(totalOtherIncome) +
                                                parseFloat(totalDeposit) -
                                                parseFloat(data?.totalExpense)
                                        ).toFixed(2)}
                                    </td>
                                </tr>
                                {/* <tr>
                                <td>Checked By:</td>
                                <td></td>
                                <td>Approved By:</td>
                                <td></td>
                                <td>Owner:</td>
                                <td>{owner?.owner?.name}</td>
                                <td></td>
                            </tr> */}
                            </tbody>
                        </table>
                    </div>
                    <div style={{ display: "flex", justifyContent: "space-between" }}>
                        <p>Checked By:</p>
                        <p>Approved By:</p>
                        <p>
                            Owner: <span>{owner?.owner?.name}</span>
                        </p>
                    </div>
                    {/* <div style={{ width: "100%", display: "flex", gap: "100px" }}>
                        <div style={{ width: "40%" }}>
                            <table>
                                <tbody>
                                    {data && data.expenses && data.expenses.length > 0 ? (
                                        data.expenses.map((val, index) => (
                                            <tr key={index}>
                                                <td>{val.name}</td>
                                                <td
                                                    style={{ textAlign: "right" }}
                                                >{Number(val.amount).toFixed(2)}</td>
                                            </tr>
                                        ))
                                    ) : (
                                        <tr>
                                            <td colSpan="2" style={{ textAlign: "center" }}>
                                                No data available
                                            </td>
                                        </tr>
                                    )}
                                    <tr>
                                        <td style={{ fontWeight: "bold" }}>Expenses Total</td>
                                        <td
                                            style={{ textAlign: "right" }}
                                        >{Number(data.totalExpense).toFixed(2)}</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                        <div>
                            <p>Prepared By:</p>
                            <p>Checked By:</p>
                            <p>Approved By:</p>
                        </div>
                    </div> */}
                    {/* <div style={{ width: "100%", display: "flex", gap: "100px" }}>
                        <div style={{ width: "40%" }}>
                            <table>
                                <tbody>
                                    <tr>
                                        <td>Rent Collection</td>
                                        <td
                                            style={{ textAlign: "right" }}
                                        >{Number(data?.totalCollectedRent).toFixed(2)}</td>
                                    </tr>
                                    <tr>
                                        <td>Deposit</td>
                                        <td
                                            style={{ textAlign: "right" }}
                                        >{Number(data?.totalDeposit).toFixed(2)}</td>
                                    </tr>
                                    <tr>
                                        <td>Expenses Total</td>
                                        <td
                                            style={{ textAlign: "right" }}
                                        >{Number(data?.totalExpense).toFixed(2)}</td>
                                    </tr>
                                    <tr>
                                        <td>Balance</td>
                                        <td style={{ textAlign: "right" }}>
                                            {Number(
                                                data?.totalCollectedRent +
                                                data?.totalDeposit -
                                                data?.totalExpense
                                            ).toFixed(2)}
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                        <div>
                            <p>
                                Owner: <span>{owner?.owner?.name}</span>
                            </p>
                        </div>
                    </div> */}
                </div>
            </div>
        </Box>
    );
};

export default AllUnits;
